import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { createQueryClient } from "@/config/query-client";
import { AuthProvider } from "@/auth/auth-context";
import { TenantProvider } from "@/tenant/tenant-context";
import { Toaster } from "@/components/ui/toaster";
import { App } from "./app";
import "./index.css";

const queryClient = createQueryClient();

// Clear query cache on logout to prevent cross-tenant data leakage
window.addEventListener("auth:logout", () => {
  queryClient.clear();
});

const rootEl = document.getElementById("root");
if (!rootEl) {
  throw new Error("Root element #root not found in document");
}

createRoot(rootEl).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <TenantProvider>
          <App />
          <Toaster />
        </TenantProvider>
      </AuthProvider>
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  </StrictMode>,
);
